import React from 'react'
import { useModel } from '@morningtrain/react-resources'

export default function UpdateModelOnChange ({ name, children, value = null, onChange, modify }) {
  const model = useModel()

  const handleOnChange = (fieldValue) => {
    if (typeof modify === 'function') {
      fieldValue = modify(fieldValue)
    }

    model.set(name, value !== null ? value : fieldValue)

    if (typeof onChange === 'function') {
      onChange(fieldValue)
    }
  }

  return React.Children.map(children, child => {
    return React.cloneElement(child, { ...(child.props || {}), onChange: handleOnChange })
  })
}
